"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.taskInventoriesLoadsExtractor = exports.taskInventoriesRejectDetailsExtractor = exports.taskInventoryExtractor = exports.taskInventoryMassQuantityExtractor = void 0;
var taskInventoryMassQuantityExtractor = function (response) {
    return response.task_inventories;
};
exports.taskInventoryMassQuantityExtractor = taskInventoryMassQuantityExtractor;
var taskInventoryExtractor = function (response) { return response.task_inventory; };
exports.taskInventoryExtractor = taskInventoryExtractor;
var taskInventoriesRejectDetailsExtractor = function (response) {
    return response.task_inventories_reject_details;
};
exports.taskInventoriesRejectDetailsExtractor = taskInventoriesRejectDetailsExtractor;
var taskInventoriesLoadsExtractor = function (response) {
    return response.loads;
};
exports.taskInventoriesLoadsExtractor = taskInventoriesLoadsExtractor;
//# sourceMappingURL=TaskInventory.consts.js.map